import enTranslationJSON from './en-US/translation.json'
import nbTranslationJSON from './nb-NO/translation.json'
import svTranslationJSON from './sv-SE/translation.json'

const resources = {
    'en-US': {
        translation: enTranslationJSON,
    },
    'nb-NO': {
        translation: nbTranslationJSON,
    },
    'sv-SE': {
        translation: svTranslationJSON,
    },
}

export default resources
